import { render, staticRenderFns } from "./PromotionsTable.vue?vue&type=template&id=664e939b&scoped=true&"
import script from "./PromotionsTable.vue?vue&type=script&lang=ts&"
export * from "./PromotionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsTable.vue?vue&type=style&index=0&id=664e939b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e939b",
  null
  
)

export default component.exports